import { handleScheduleAvailability } from './handle-schedule-availability.util';

export const getOpenCloseHours = (schedule) => {
    const today = new Date().getDay(); // 0 (domingo) hasta 6 (sábado)
    const index = today === 0 ? 6 : today - 1;
    const closureHour = schedule[index].close.split(':')[0];

    if (!handleScheduleAvailability(schedule)) {
        const nextIndex = (index + 1) % schedule.length;
        const openingHour = schedule[nextIndex].open.split(':')[0];
        return openingHour;
    }

    return closureHour;
  };